import React from 'react'
import { connect } from 'react-redux'
import { BsrsGrid, Column, commandColumnProps, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import { Main, MainTop, MainTopTitle, MainBody, MainTopLeft } from '@/components/Layout'
import Icon from '@/components/Icon'
import { Button } from 'reactstrap'
import { localized } from '@/decorators/localized'
import context from '@/context'
import Resx from '@/components/Resx'
import { dialogTypes } from '@/dialogs'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { actionCreators } from '@/store/ReportingYear'
import LoadingIndicator from '@/components/LoadingIndicator'
import CreateReportingYearDialog from '@/internal-app/pages/years/CreateReportingYearDialog'
import { withPermissions } from '@/decorators/withPermissions'

@localized()
@withPermissions()
class ReportingYears extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      isOpen: false
    }
  }
  componentDidUpdate (prevProps, prevState) {
    const { createdYearResponse } = this.props.reportingYear
    if (createdYearResponse !== null) {
      if (createdYearResponse.isOk === false) {
        this.props.openDialog({
          dialogType: dialogTypes.alert,
          title: 'Reporting.CreateNewYearTitle',
          content: createdYearResponse.message
        })
      }
      this.props.clearCreateYearResponse()
    }
  }
  handleSaveChanges (year) {
    this.setState({ isOpen: false }, () => this.props.createYear(Number(year)))
  }
  canManage () { return this.props.isGranted('CanManageReportingCalendars') }
  render () {
    const { localize } = this.props
    if (this.props.reportingYear.creating === true) {
      return (<LoadingIndicator />)
    }
    const canManage = this.canManage()
    return (
      <React.Fragment>
        <Main>
          <MainTop>
            <MainTopTitle>
              <Resx name='Reporting.ReportingYearsTitle' />
            </MainTopTitle>
            <MainTopLeft>
              {canManage && <Button color='primary' className='btn-sm' onClick={() => this.setState({ isOpen: true })}>
                <Icon name='plus' /><span><Resx name='Reporting.AddReportingCalendar' /></span>
              </Button>}
            </MainTopLeft>
          </MainTop>
          <MainBody>
            <BsrsGrid persistenceId={'reporting-year'} dataSource={context.api.reportingYearService.getAllTableData}
              defaultSort={[{ field: 'number', dir: 'desc' }]}>
              <Column field='number' title={localize('Reporting.Year')} filter='numeric' editable={false} />
              <Column field='lastUpdatedAt' title={localize('Reporting.LastUpdatedAt')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} />
              <Column {...commandColumnProps({ detailUrl: x => `/reporting-calendars/${x.number}/reporting-cycles` })} title={localize('Reporting.ReportingCycles')} width={150} />
              <Column {...commandColumnProps({ detailUrl: x => `/reporting-calendars/${x.number}/holidays` })} title={localize('Reporting.Holidays')} width={150} />
            </BsrsGrid>
          </MainBody>
        </Main>
        <CreateReportingYearDialog
          isOpen={this.state.isOpen}
          onCancel={() => this.setState({ isOpen: false })}
          onSaveChanges={year => this.handleSaveChanges(year)} />
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    reportingYear: state.reportingYear,
    ...ownProps
  }
}

const mapDispatchToProps = {
  openDialog: dialogActions.openDialog,
  createYear: actionCreators.createYear,
  clearCreateYearResponse: actionCreators.clearCreateYearResponse
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportingYears)



// WEBPACK FOOTER //
// ./src/internal-app/pages/years/ReportingYears.js